import MapLeafletContainer from './components/Map/base/MapLeafletContainer';
import { leafletDrawLanguageConfig } from './configs/leafletDrawLanguageConfig';
// const v8 = require('v8');

// Set the maximum heap size (memory limit) to 4 GB (in bytes)
// const memoryLimitInBytes = 4 * 1024 * 1024 * 1024; // 4 GB
// v8.setFlagsFromString(`--max-old-space-size=${memoryLimitInBytes}`);
function App() {
    leafletDrawLanguageConfig();
    return <MapLeafletContainer />;
}

export default App;
